export type Role = 'compras' | 'dropshipper' | 'administrator';
export const ROLE_COMPRAS: Role = 'compras';
export const ROLE_DROPSHIPPER: Role = 'dropshipper';
export const ROLE_ADMINISTRATOR: Role = 'administrator';
